// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonLabels = {
  empty: "-",
  none: "なし",
  loading: "読み込み中...",
  total: "合計",
  archived: "アーカイブ済み",
  hidden: "非表示",
  emptyText: "（空）",
  avatarAlt: "アバター",
  versionTag: "V1",
  nonePaper: "試験用紙なし",
  uncategorized: "未分類",
  notSet: "未設定",
  noData: "データなし",
  pleaseSelect: "選択してください",
  online: "オンライン",
  offline: "オフライン",
} as const;
